// extracted by mini-css-extract-plugin
export var drawerPaper = "_24-0";
export var itemCard = "_24-1";
export var itemImage = "_24-2";